import { type SegmentedControlOption } from '@air/component-segmented-control';

import { type PermissionMode } from '~/components/SharePrivateCollectionModal/types';

/**
 * Type-safe helper to convert a SegmentedControlOption to PermissionMode.
 * Validates that the option.id is a valid PermissionMode value.
 */
export function toPermissionMode(option: SegmentedControlOption): PermissionMode {
  if (option.id === 'hide' || option.id === 'read-only' || option.id === 'allow') {
    return option.id;
  }

  throw new Error(`Invalid permission mode: ${option.id}`);
}
